import { IconButton } from '@chakra-ui/core';
import { DragHandleIcon } from '@chakra-ui/icons';
import React, { useCallback, useState } from 'react';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { useDragAndDrop } from '../../hooks/useDragAndDrop';

const DRAG_HANDLE_PROPS = {
  'aria-label': 'Drag element',
  size: 'sm',
  variant: 'ghost',
  cursor: 'grab',
} as const;

export const QuestionDraggableButton = React.memo(function QuestionDraggableButton({ id }: { id: string }) {
  const type = QuestionnaireTemplateStore.useStoreState((state) => state.getElementValue(id, 'questionType'));
  const updateValue = QuestionnaireTemplateStore.useStoreActions((actions) => actions.updateElementValue);
  const { handleDragStart, handleDragEnd } = useDragAndDrop();

  const [isDragging, setIsDragging] = useState(false);

  const onPointerDown = useCallback(
    (e: React.PointerEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setIsDragging(true);

      updateValue({ id, path: 'expanded', value: false });

      handleDragStart(e, { id, type, isNew: false });
    },
    [id, type, handleDragStart, updateValue],
  );

  const onPointerUp = useCallback(
    (e: React.PointerEvent<HTMLButtonElement>) => {
      setIsDragging(false);

      updateValue({ id, path: 'expanded', value: true });

      handleDragEnd(e);
    },
    [id, handleDragEnd, updateValue],
  );

  return (
    <IconButton
      {...DRAG_HANDLE_PROPS}
      tabIndex={-1}
      icon={<DragHandleIcon fontSize={16} />}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
      data-dragging={isDragging || undefined}
      cursor={isDragging ? 'grabbing' : 'grab'}
    />
  );
});
